// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Belt_SetString = require("bs-platform/lib/js/belt_SetString.js");

function toBoolean(hint, $$default) {
  switch (hint) {
    case /* Enable */0 :
        return true;
    case /* Disable */1 :
        return false;
    case /* Auto */2 :
        return $$default;
    
  }
}

function fromString(tok) {
  switch (tok) {
    case "disable" :
        return /* Disable */1;
    case "enable" :
        return /* Enable */0;
    default:
      return /* Auto */2;
  }
}

function filterPragmasByFeature(pragmas, feature) {
  return Belt_List.keep(pragmas, (function (pragma) {
                if (pragma) {
                  return pragma[0] === feature;
                } else {
                  return false;
                }
              }));
}

function replace($staropt$star, str, regex, sub) {
  var flags = $staropt$star !== undefined ? $staropt$star : "gm";
  return str.replace(new RegExp(regex, flags), sub);
}

function remove($staropt$star, str, regex) {
  var flags = $staropt$star !== undefined ? $staropt$star : "gm";
  return replace(flags, str, regex, "");
}

function test($staropt$star, str, regex) {
  var flags = $staropt$star !== undefined ? $staropt$star : "gm";
  return new RegExp(regex, flags).test(str);
}

function matches($staropt$star, str, regex) {
  var flags = $staropt$star !== undefined ? $staropt$star : "gm";
  var reObj = new RegExp(regex, flags);
  var fullMatch = function (execResult) {
    return Belt_Option.getExn(Caml_option.nullable_to_opt(Belt_Array.getExn(execResult, 0)));
  };
  var captureNext = function (param) {
    var match = reObj.exec(str);
    if (match !== null) {
      return Belt_List.add(captureNext(/* () */0), fullMatch(match));
    } else {
      return /* [] */0;
    }
  };
  return captureNext(/* () */0);
}

function stripCppComments(code) {
  return remove(undefined, replace(undefined, code, "(?:\\/\\/(?:\\\\\\n|[^\\n])*)|(?:\\/\\*[\\s\\S]*?\\*\\/)|((?:\"([^(\\\\\\s])\\([^)]*\\)\\2\")|(?:@\"[^\"]*?\")|(?:\"(?:\\?\\?'|\\\\\\\\|\\\\\"|\\\\\\n|[^\"])*?\")|(?:'(?:\\\\\\\\|\\\\'|\\\\\\n|[^'])*?'))", "$1"), "\\s*$");
}

function doesReferSymbol(symbol, code) {
  return test(undefined, stripCppComments(code), "\\b" + (symbol + "\\b"));
}

function doesReferTemplateSymbol(symbol, templateArg, code) {
  return test(undefined, stripCppComments(code), "\\b" + (symbol + ("\\s*\\<\\s*" + (templateArg + "\\s*\\>"))));
}

var pragmaHeadRegexp = "#\\s*pragma\\s+XOD\\s+";

var pragmaLineRegexp = "#\\s*pragma\\s+XOD\\s+.*";

function tokenizePragma(pragmaLine) {
  return Belt_List.map(matches(undefined, remove(undefined, pragmaLine, pragmaHeadRegexp), "[\\w._-]+|\".*?\""), (function (token) {
                return remove(undefined, token, "^\"|\"$");
              }));
}

function findXodPragmas(code) {
  return Belt_List.map(matches(undefined, stripCppComments(code), pragmaLineRegexp), tokenizePragma);
}

function lastPragmaEndis(code, feature) {
  var lastPragma = Belt_List.head(Belt_List.reverse(filterPragmasByFeature(findXodPragmas(code), feature)));
  if (lastPragma !== undefined) {
    var match = lastPragma;
    if (match) {
      var match$1 = match[1];
      if (match$1) {
        return fromString(match$1[0]);
      } else {
        return /* Auto */2;
      }
    } else {
      return /* Auto */2;
    }
  } else {
    return /* Auto */2;
  }
}

function areTimeoutsEnabled(code) {
  return toBoolean(lastPragmaEndis(code, "timeouts"), doesReferSymbol("setTimeout", code));
}

function isSetImmediateEnabled(code) {
  return toBoolean(lastPragmaEndis(code, "immediate"), doesReferSymbol("setImmediate", code));
}

function isNodeIdEnabled(code) {
  return toBoolean(lastPragmaEndis(code, "nodeid"), doesReferSymbol("getNodeId", code));
}

function doesRaiseErrors(code) {
  return toBoolean(lastPragmaEndis(code, "error_raise"), doesReferSymbol("raiseError", code));
}

function isDirtienessEnabled(code, identifier) {
  return Belt_List.reduce(findXodPragmas(code), test(undefined, identifier, "^output_") || doesReferTemplateSymbol("isInputDirty", identifier, code), (function (acc, pragma) {
                if (pragma && pragma[0] === "dirtieness") {
                  var match = pragma[1];
                  if (match) {
                    var match$1 = match[1];
                    var hintTok = match[0];
                    if (match$1 && (match$1[1] || match$1[0] !== identifier)) {
                      return acc;
                    } else {
                      return toBoolean(fromString(hintTok), acc);
                    }
                  } else {
                    return acc;
                  }
                } else {
                  return acc;
                }
              }));
}

function getEvaluateOnPinSettings(code) {
  return Belt_List.reduce(filterPragmasByFeature(findXodPragmas(code), "evaluate_on_pin"), {
              enabled: true,
              exceptions: Belt_SetString.empty
            }, (function (acc, pragma) {
                if (pragma) {
                  var match = pragma[1];
                  if (match) {
                    switch (match[0]) {
                      case "disable" :
                          var disabledPins = match[1];
                          if (disabledPins) {
                            return {
                                    enabled: acc.enabled,
                                    exceptions: acc.enabled ? Belt_SetString.mergeMany(acc.exceptions, Belt_List.toArray(disabledPins)) : Belt_SetString.removeMany(acc.exceptions, Belt_List.toArray(disabledPins))
                                  };
                          } else {
                            return {
                                    enabled: false,
                                    exceptions: Belt_SetString.empty
                                  };
                          }
                      case "enable" :
                          var enabledPins = match[1];
                          if (enabledPins) {
                            return {
                                    enabled: acc.enabled,
                                    exceptions: acc.enabled ? Belt_SetString.removeMany(acc.exceptions, Belt_List.toArray(enabledPins)) : Belt_SetString.mergeMany(acc.exceptions, Belt_List.toArray(enabledPins))
                                  };
                          } else {
                            return {
                                    enabled: true,
                                    exceptions: Belt_SetString.empty
                                  };
                          }
                      default:
                        return acc;
                    }
                  } else {
                    return acc;
                  }
                } else {
                  return acc;
                }
              }));
}

function doesCatchErrors(code) {
  return toBoolean(lastPragmaEndis(code, "error_catch"), doesReferSymbol("getError", code));
}

function findRequireUrls(code) {
  return Belt_List.reduce(findXodPragmas(code), /* [] */0, (function (acc, v) {
                if (v && v[0] === "require") {
                  var match = v[1];
                  if (match && !match[1]) {
                    var url = match[0];
                    if (test(undefined, url, "^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$")) {
                      return /* :: */[
                              url,
                              acc
                            ];
                    } else {
                      return acc;
                    }
                  } else {
                    return acc;
                  }
                } else {
                  return acc;
                }
              }));
}

var Pragma = { };

exports.Pragma = Pragma;
exports.areTimeoutsEnabled = areTimeoutsEnabled;
exports.isSetImmediateEnabled = isSetImmediateEnabled;
exports.isNodeIdEnabled = isNodeIdEnabled;
exports.doesRaiseErrors = doesRaiseErrors;
exports.isDirtienessEnabled = isDirtienessEnabled;
exports.doesCatchErrors = doesCatchErrors;
exports.findXodPragmas = findXodPragmas;
exports.getEvaluateOnPinSettings = getEvaluateOnPinSettings;
exports.findRequireUrls = findRequireUrls;
exports.stripCppComments = stripCppComments;
/* No side effect */



// WEBPACK FOOTER //
// ../src/Directives.bs.js